document.addEventListener('DOMContentLoaded', function () {
    // Alle Radio-Buttons überwachen
    const variantRadios = document.querySelectorAll('.product-form__input input[type="radio"]');
    
    variantRadios.forEach((radio, index) => {
        radio.addEventListener('change', function () {
            // Elemente der zweiten Variante
            const secondVariantSavePrice = document.querySelectorAll('.custom-variant-bar:nth-child(2) .custom-variant-save-price');
            const secondVariantSavePercent = document.querySelectorAll('.custom-variant-bar:nth-child(2) .custom-variant-save-percent');
            
            if (index === 2 && radio.checked) {
                // Wenn die dritte Variante ausgewählt wird, verstecke die Klassen der zweiten Variante
                secondVariantSavePrice.forEach(el => el.style.display = 'none');
                secondVariantSavePercent.forEach(el => el.style.display = 'none');
            } else {
                // Wenn irgendeine andere Variante (inkl. der zweiten) ausgewählt wird, blende die Klassen der zweiten Variante wieder ein
                secondVariantSavePrice.forEach(el => el.style.display = '');
                secondVariantSavePercent.forEach(el => el.style.display = '');
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function() {
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            document.querySelectorAll('.wc_review_badge_inner').forEach(function(badgeInnerElement) {
                if (badgeInnerElement.getAttribute('data-count') === "0") {
                    let badgeElement = badgeInnerElement.closest('.wc_product_review_badge');
                    if (badgeElement) {
                        badgeElement.style.display = 'none';
                    }
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

function toggleSubmenu(element) {
  const submenu = element?.nextElementSibling;
  const arrowIcon = element.querySelector('.sh-mobile-nav-link-item-svg');
  if (!submenu) return;

  if (submenu.style.maxHeight) {
    // Close submenu
    submenu.style.maxHeight = null;
    arrowIcon.style.transform = 'rotate(0deg)';
    submenu.classList.remove('active');
  } else {
    // Open submenu
    submenu.style.maxHeight = '800px';
    arrowIcon.style.transform = 'translateY(-50%) rotate(180deg)';
    submenu.classList.add('active');
  }
}


// Upsell App additional JS

  const observer = new MutationObserver(() => {
    const discountEls = document.querySelectorAll('.lb-bundle-cont .lb-price-discount');

    discountEls.forEach(discountEl => {
      if (discountEl.dataset.modified) return;

      const lbPriceEl = discountEl.closest('.lb-price');
      if (!lbPriceEl) return;

      const bundleCtaCont = lbPriceEl.closest('.lb-bundle-cta-total-cont');
      const isInsideBundle = bundleCtaCont && bundleCtaCont.closest('.lb-bundle-cont');

      if (isInsideBundle) {
        const originalText = discountEl.textContent.trim();
        const cleanPercent = originalText.replace('-', '').trim();
        discountEl.textContent = 'Du sparst ' + cleanPercent;

        const compareCont = lbPriceEl.querySelector('.lb-compare-cont');
        const salePrice = lbPriceEl.querySelector('.lb-price-sale-price.money');

        if (compareCont && salePrice && salePrice.parentElement === lbPriceEl) {
          const comparePrice = compareCont.querySelector('.lb-price-compare-price');
          if (comparePrice && comparePrice.nextSibling) {
            compareCont.insertBefore(salePrice, comparePrice.nextSibling);
          } else {
            compareCont.appendChild(salePrice);
          }

          if (compareCont.nextSibling !== discountEl) {
            lbPriceEl.insertBefore(discountEl, compareCont.nextSibling);
          }
        }
      } else {
        discountEl.textContent = 'BUNDLE DEAL';
      }

      discountEl.dataset.modified = "true";
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // 🔄 Hier der zweite Observer mit anderem Namen
const observer2 = new MutationObserver(() => {
  const customTextEl = document.querySelector('#app-sale-badge-text');
  const customText = customTextEl?.dataset.text?.trim() || '';

  const colorSettingsEl = document.querySelector('#app-sale-badge-color');
  const badgeBgColor = colorSettingsEl?.dataset.background || '';
  const badgeTextColor = colorSettingsEl?.dataset.text || '';

  document.querySelectorAll('lb-price').forEach(lbPrice => {
    const hasDiscountBadge = lbPrice.querySelector('.lb-price-discount');
    const comparePriceEl = lbPrice.querySelector('.lb-price-compare-price');
    const salePriceEl = lbPrice.querySelector('.lb-price-sale-price');

    if (hasDiscountBadge || !comparePriceEl || !salePriceEl) return;

    const compareText = comparePriceEl.textContent.replace(/[^\d,.]/g, '').replace(',', '.');
    const saleText = salePriceEl.textContent.replace(/[^\d,.]/g, '').replace(',', '.');

    const compare = parseFloat(compareText);
    const sale = parseFloat(saleText);

    if (isNaN(compare) || isNaN(sale) || compare <= sale) return;

    const discountPercent = Math.round(((compare - sale) / compare) * 100);

    const badge = document.createElement('div');
    badge.className = 'lb-price-discount';
    badge.textContent = `${customText} ${discountPercent}%`;

    // 🎨 Farben anwenden, wenn vorhanden
    if (badgeBgColor) badge.style.backgroundColor = badgeBgColor;
    if (badgeTextColor) badge.style.color = badgeTextColor;

    const compareCont = lbPrice.querySelector('.lb-compare-cont');
    if (compareCont) {
      compareCont.appendChild(badge);
    }
  });
});

observer2.observe(document.body, {
  childList: true,
  subtree: true
});

